import React from 'react';
import useSWR from 'swr';
import { Location, locationFetcher } from '../../data/Location';
import { listDeviceFetcher, Device } from '../../data/Device';
import { AxiosError } from 'axios';
import { Skeleton, Text, Paper, Anchor, Breadcrumbs } from '@mantine/core';
import { useNavigate, useParams } from 'react-router-dom';

const LocationDetail: React.FC = () => {
    const navigate = useNavigate();
    const handleNav = (route: string) => {
        navigate(route);
    };
    const { locationId } = useParams();
    const {
        data: location,
        isLoading,
        error,
    } = useSWR<Location, AxiosError>(`api/location/${locationId}`, locationFetcher);
    const {
        data: devices,
        isLoading: devicesLoading,
        error: devicesError,
    } = useSWR<Device[], AxiosError>(locationId ? `api/location/${locationId}/devices` : null, listDeviceFetcher);

    if (isLoading) return <Skeleton />;
    if (error) return <p>Error: {error.message}</p>;

    return (
        <div>
            <Breadcrumbs separatorMargin="xs" separator={<Text size="sm" fw={500}>/</Text>}>
                <Anchor size="sm" fw={500} onClick={() => handleNav('/')}>
                    Home
                </Anchor>
                <Anchor size="sm" fw={500} onClick={() => handleNav('/locations')}>
                    Locations
                </Anchor>
                <Text size="sm">{location?.name}</Text>
            </Breadcrumbs>
            <h2>{location?.name}</h2>
            <Text>{location?.address}</Text>
            <Text>
                {location?.city}, {location?.state} {location?.zip}
            </Text>
            <hr />
            <Text fw={500}>Devices at this location</Text>
            {devicesLoading && <Skeleton height={48} mt="sm" />}
            {devicesError && <Text c="red">Could not load devices.</Text>}
            {devices?.length === 0 && !devicesLoading && <Text size="sm">No devices assigned to this location.</Text>}
            {devices?.map(d => (
                <Paper key={d.id} shadow="xs" p="lg" style={{ marginBottom: '16px' }} mt="sm">
                    <Anchor onClick={() => handleNav(`/device/${d.id}`)}>{d.name}</Anchor>
                </Paper>
            ))}
        </div>
    );
};

export default LocationDetail;
